import { isEqualByString } from 'utils/predicates/string/simple.util';

/**
 * Whether drag/move should be blocked for an appointment procedure due to personal-only move permission.
 *
 * No-access is handled separately via `appointmentPerms.isMoveBlocked`.
 */
export const determineIfAppointmentMoveBlocked = ({ appointmentPerms, procedureStylistId }) => {
  if (!appointmentPerms?.isMovePersonalOnly) return false;
  if (procedureStylistId == null || procedureStylistId === '') return false;

  return !isEqualByString(procedureStylistId, appointmentPerms.accessStylistId);
};
